import { put, takeEvery } from 'redux-saga/effects';
import Querystring from 'querystring';
import types from 'redux/types';
import Services from 'services';
import { isResponseSuccess } from 'helpers';
import { AUTO_REPLIES_SERVLET_URL } from 'consts/api';
import hooks from 'hooks';
import { TIME_OUT_CLOSE_TOAST } from 'consts/data';
import { showError } from 'helpers/handleError';

const {
  REQUEST_API_AUTO_REPLIES_SERVLET,
  REQUEST_API_AUTO_REPLIES_SERVLET_SUCCESS,
  REQUEST_API_AUTO_REPLIES_SERVLET_FAILED,
  REQUEST_CLEAR_AUTO_REPLIES_SERVLET,
  REQUEST_CLEAR_AUTO_REPLIES_SERVLET_SUCCESS,
  REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS,
  REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS_SUCCESS,
  REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS_FAILED,
} = types;

function* changeStatusReplies(data) {
  const { status, sessionId } = data;
  const groupId = typeof data.groupId === 'string' ? Number(data.groupId) : data.groupId;
  const { Notification } = hooks;

  try {
    const body = Querystring.stringify({
      action: 'changeResponseStatus',
      groupId,
      status,
      sessionId,
    });
    const response = yield Services.post(AUTO_REPLIES_SERVLET_URL, body);
    if (isResponseSuccess(response.status)) {
      if (typeof response.data === 'string') {
        if (response.data.toLowerCase() === 'success') {
          Notification('success', 'Change Status Successfully', 'Notice', TIME_OUT_CLOSE_TOAST);
          yield put({
            type: REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS_SUCCESS,
            groupId,
            status,
          });
        } else {
          Notification('warning', `Required atleast one keyword`, 'Warning', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS_FAILED, groupId });
        }
      }
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS_FAILED, error, groupId });
  }
}

function* getRepliesServlet(data) {
  try {
    const body = Querystring.stringify({
      action: 'loadAllReplies',
      sessionId: data.token,
    });
    const response = yield Services.post(AUTO_REPLIES_SERVLET_URL, body);
    if (isResponseSuccess(response.status)) {
      if (typeof response.data === 'object' && response.data) {
        yield put({ type: REQUEST_API_AUTO_REPLIES_SERVLET_SUCCESS, data: response.data });
      } else {
        yield put({ type: REQUEST_API_AUTO_REPLIES_SERVLET_FAILED, error: 'FAIL' });
      }
    }
  } catch (error) {
    yield put({ type: REQUEST_API_AUTO_REPLIES_SERVLET_FAILED, error });
  }
}

function* clearRepliesServlet() {
  yield put({ type: REQUEST_CLEAR_AUTO_REPLIES_SERVLET_SUCCESS });
}

export default function* watchGetAPIFunction() {
  yield takeEvery(REQUEST_API_AUTO_REPLIES_SERVLET_CHANGE_STATUS, changeStatusReplies);
  yield takeEvery(REQUEST_API_AUTO_REPLIES_SERVLET, getRepliesServlet);
  yield takeEvery(REQUEST_CLEAR_AUTO_REPLIES_SERVLET, clearRepliesServlet);
}
